export type IItemMenu = {
  display: string
  isHeader?: boolean
  prependIcon?: boolean
  appendBadge?: boolean
  borderColor?: string
}
export type IGenericFilter = {
  _id: string
  display: string
}

export type IGenericSelect = {
  _id: string
  display: string
  value: boolean
}
export type TColors =
	| 'primary'
	| 'success'
	| 'warning'
	| 'base'
	| 'base-varient'
	| 'error'
	| 'errorLight'
	| 'loading'
	| 'disabled'
	| 'disabledLight'
	| 'transparent'

export type TSize = 'mini' | 'dense' | 'small' | 'normal'

export enum EModalPosition {
  base = 'base',
  bottom = 'bottom',
  right = 'right',
  left = 'left',
  top = 'top',
  topFull = 'topFull',
}
export enum EModalAnimation {
  base = 'fade-scale',
  bottom = 'fade-y-bottom',
  right = 'fade-x-right',
}

export type IFile = {
  fileName: string
  base64: string
  fileType: string
  fileSize: number
  fileDescription?: string
}

export type TLoadingStatus = 'loading' | 'success' | 'error' | null | undefined
